import { Id, toast } from 'react-toastify';
import { ReactNode } from 'react';

const activeToastIds: Id[] = [];
const dismissedToastIds: Id[] = [];

/**
 * Shows a singleton toast after dismissing all current toasts.
 * autoClose (in ms) is handled manually to prevent Toastify conflicts.
 */
export const showSingletonToast = (
    content: ReactNode | string,
    options?: Omit<Parameters<typeof toast>[1], 'autoClose'> & { autoClose?: boolean | number }
): Id => {
    activeToastIds.forEach((id) => {
        toast.dismiss(id);
        dismissedToastIds.push(id);
    });

    const id = toast(content, {
        ...options,
        autoClose: false,
        onOpen: () => {
            const dismissedIndex = dismissedToastIds.indexOf(id);
            if (dismissedIndex !== -1) {
                toast.dismiss(id);
                dismissedToastIds.splice(dismissedIndex, 1);
            }
        },
        onClose: () => {
            const activeIndex = activeToastIds.indexOf(id);
            if (activeIndex !== -1) {
                activeToastIds.splice(activeIndex, 1);
            }
        },
    });

    activeToastIds.push(id);

    if (typeof options?.autoClose === 'number') {
        setTimeout(() => {
            toast.dismiss(id);
            dismissedToastIds.push(id);
        }, options.autoClose);
    }

    return id;
};

export const dismissSingletonToast = (): void => {
    activeToastIds.forEach((id) => {
        toast.dismiss(id);
        dismissedToastIds.push(id);
    });
};
